// ********************************************************************************************************************
// 商城
// ********************************************************************************************************************
const Mall = () => import('views/mall/Mall')
const SeckillIndex = () => import('views/mall/SeckillIndex')
const SeckillPage = () => import('views/mall/SeckillPage')
const SeckillConfig = () => import('views/mall/SeckillConfig')
const OrderPay = () => import('views/mall/OrderPay')
const Order = () => import('views/mall/Order')
const Cart = () => import('views/mall/Cart')
const Fav = () => import('views/mall/Fav')

export default {
  path: '/mall',
  name: 'Mall',
  component: Mall,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: '概览',
      component: SeckillIndex,
      meta: { needAuth: false }
    },
    {
      path: '/mall/item',
      name: 'SeckillPage',
      component: SeckillPage,
      meta: { title: 'SeckillPage', needAuth: false }
    },
    {
      path: '/mall/seckill',
      name: 'SeckillConfig',
      component: SeckillConfig,
      meta: { title: 'SeckillConfig', needAuth: false }
    },
    {
      path: '/mall/order/pay',
      name: 'OrderPay',
      component: OrderPay,
      meta: { title: 'OrderPay', needAuth: false }
    },
    {
      path: '/mall/order',
      name: 'Order',
      component: Order,
      meta: { title: 'Order', needAuth: false }
    },
    {
      path: '/mall/cart',
      name: 'Cart',
      component: Cart,
      meta: { title: 'Cart', needAuth: false }
    },
    {
      path: '/mall/fav',
      name: 'Fav',
      component: Fav,
      meta: { title: 'Fav', needAuth: false }
    }
  ]
}
